import { render, staticRenderFns } from "./RegisterNew.vue?vue&type=template&id=7e2f20da&scoped=true"
import script from "./RegisterNew.vue?vue&type=script&lang=js"
export * from "./RegisterNew.vue?vue&type=script&lang=js"
import style0 from "./RegisterNew.vue?vue&type=style&index=0&id=7e2f20da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2f20da",
  null
  
)

export default component.exports